export enum SplitType {
  'floor',
  'ceil'
}

export const enum StorageType {
  Local = 'local',
  Session = 'session'
}

export const enum RequestType {
  Get = 'get',
  Post = 'post',
  Put = 'put',
  Delete = 'delete'
}
